export default {
  home: {
    sections: {
      trendingParlays: "Múltiplas populares do dia",
    },
    checkout: {
      placeItOn: "Aposte na",
    },
    matchups: {
      today: "Matchups de hoje",
      thisWeek: "Matchups desta semana",
      upcoming: "Próximos matchups",
    },
    actions: {
      claimNow: "Resgatar agora",
      showMore: "Mostrar mais",
      showLess: "Mostrar menos",
    },
    empty: {
      parlayMinGames: "Nenhuma tendência disponível ainda. Mínimo de 3 jogos necessário.",
    },
    hundredPercentClub: {
      subtitle: "Props que acertaram em 100% dos jogos",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Encontre valor quando as escalações iniciais mudarem. Incluído com",
        injuryImpact: "Veja como lesões impactam companheiros de equipe. Incluído com",
        opponentRank: "Explore matchups defensivos favoráveis. Incluído com",
        startingPitchers: "Mire situações contra arremessadores vulneráveis. Incluído com",
        weatherReport: "Use vento e tempo a seu favor. Incluído com",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Carregando mercados...",
        loadError: "Não foi possível carregar os mercados.",
      },
    },
    sidebar: {
      downloadApp: "Baixe o app",
      neverMissTrend: "Não perca nenhuma tendência",
      unlockAnalysis: "Desbloqueie a análise completa",
      unlock: "Desbloquear",
      mostBetOn: "Mais apostados",
      mostSearched: "Mais buscados",
      trendingLeagues: "Ligas populares",
      topOffers: "O melhor de {{type}}",
      newsletter: {
        title: "Fique à frente das tendências",
        description: "Junte-se a <strong>mais de 30.000 apostadores esportivos</strong> que recebem análises e ofertas da Linemate por e-mail.",
        subscribe: "Inscrever-se",
        subscribedTitle: "Você está inscrito!",
        subscribedBody: "Enviaremos as últimas tendências e ofertas da Linemate para o seu e-mail.",
      },
      improveExperience: "Melhore sua experiência Linemate",
      getAccess: "TENHA ACESSO A JOGADAS AVANÇADAS E INSIGHTS MAIS PROFUNDOS",
    },
  },
};
